export function AttendanceStats(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/stats/attendance`;
}

export function ByExternalSource(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/with-videosource`;
}

export function ConnectWithWingfieldAccount(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/wingfield/connect`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users`;
}

export function DefaultPaymentSource(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/default-payment-source`;
}

export function Delete(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users`;
}

export function DeleteWingfieldConnection(organizationID: number, connectionID: number): string {
	return `/v1/organizations/${organizationID}/wingfield/connections/${connectionID}`;
}

export function DeregisterPushNotificationDevice(ID: number): string {
	return `/v1/me/pns/${ID}`;
}

export function GameStats(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/stats/game`;
}

export function GameStatsDetailed(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/stats/game-detailed`;
}

export function IgnoreSuspectedDuplicates(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/suspected-duplicates/ignore`;
}

export function ListActivePaymentMethods(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/payment-methods/active`;
}

export function ListPaymentMethods(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/payment-methods`;
}

export function ListRelatives(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/relatives`;
}

export function ListUserProducts(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/user-products`;
}

export function ListVideos(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/videos`;
}

export function ListWingfieldConnections(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/wingfield/connections`;
}

export function Merge(organizationID: number, userID: number, sourceUserID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/merge/${sourceUserID}`;
}

export function PhysicalStrainStats(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/stats/physical-strain`;
}

export function RegisterPushNotificationDevice(): string {
	return `/v1/me/pns`;
}

export function SetBillingUserToLegalGuardian(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/set-billing-user-to-legal-guardian`;
}

export function Show(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}`;
}

export function ShowLoginInformation(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/login-information`;
}

export function SuspectedDuplicates(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/suspected-duplicates`;
}

export function Undelete(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/undelete`;
}

export function UnignoreSuspectedDuplicates(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/suspected-duplicates/unignore`;
}

export function Update(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}`;
}

